import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=04ea982b&scoped=true&"
import script from "./PanelGroup.vue?vue&type=script&lang=js&"
export * from "./PanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=04ea982b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea982b",
  null
  
)

export default component.exports